import { useEffect, useState } from "react";

/**
 * Returns a copy of `value` that only updates after `delayMs` of stable input.
 * Useful for debouncing search inputs to avoid hammering the backend on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
